
export const Info =
  "Your go-to app for buying online fresh produce from the safety & comfort of your home. ";

